import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { RouteConstantsInterface } from '@hrms/common/constant/types';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export enum RouteConstantEnums {
  TRACKING = '/tracking',
  RATE_CARD_MANAGEMENT = '/rate-card-management',
}

export const RouteConstants: RouteConstantsInterface = {
  TRACKING: 'referral/tracking',
  RATE_CARD_MANAGEMENT: '/referral/rate-card-management',
};
const getReferralModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.REFERRAL_RATE_CARD_MANAGEMENT,
      route: RouteConstants.RATE_CARD_MANAGEMENT,
      title: ScreenNames.REFERRAL_RATE_CARD_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'users',
        alt: 'rate-card-management',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.REFERRAL_RATE_CARD_MANAGEMENT,
    },
  ];
};

export { getReferralModuleRoutes };
